module.exports = __webpack_public_path__ + "img/titania.7e40eb58.png";